import ConfigurazioneAgendaBoxListPage from "./pages/ConfigurazioneAgendaBoxListPage.vue";
export default { ConfigurazioneAgendaBoxListPage };
